import angular from 'angular';
import constants from 'app/constants';
import {
  orgDataService,
  bcpDataService,
  bcpUtilityService,
  loaderService,
  ssDialogService
} from 'app/services';
import {
  confirmDialog, alerts
} from 'app/components/global';
import controller from './edit-authority-and-management-dialog.controller';
import template from './edit-authority-and-management-dialog.html';
import editInternalContactDialog from '../dialog.editInternalContactDialog';


class dialogService {
  getOptions($event, {
    customerId,
    assessmentId,
    internalContacts,
    permissions
  }) {
    return {
      controller,
      controllerAs: 'editAuthorityAndManagementDialogVM',
      locals: {
        customerId,
        assessmentId,
        internalContacts,
        permissions,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.bcp.editAuthorityAndManagementDialog', [
  confirmDialog,
  alerts,
  orgDataService,
  bcpDataService,
  constants,
  bcpUtilityService,
  loaderService,
  ssDialogService,
  editInternalContactDialog,
])
  .service('editAuthorityAndManagementDialog', dialogService)
  .name;
